import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const PolitiqueConfidentialite = () => {
  const { t } = useTranslation();
  
  // Mise à jour du titre de la page
  useEffect(() => {
    document.title = "SOCABEG - Société d'Aménagement de Bâtiment et d'Etudes Générales";
  }, []);

  return (
    <div>
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6 mb-8">
          <h2 className="text-2xl font-bold text-socabeg-blue mb-6">{t('privacy.title')}</h2>
          <p className="mb-4">{t('privacy.lastUpdate')}: {new Date().toLocaleDateString()}</p>
          
          <div className="space-y-6">
            <section>
              <h3 className="text-xl font-semibold mb-3">{t('privacy.introduction.title')}</h3>
              <p className="mb-4">{t('privacy.introduction.text1')}</p>
              <p className="mb-4">{t('privacy.introduction.text2')}</p>
            </section>
            
            <section>
              <h3 className="text-xl font-semibold mb-3">{t('privacy.collection.title')}</h3>
              <p className="mb-4">{t('privacy.collection.intro')}</p>
              
              <h4 className="text-lg font-medium mb-2">{t('privacy.collection.provided.title')}</h4>
              <p className="mb-4">{t('privacy.collection.provided.intro')}</p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>{t('privacy.collection.provided.item1')}</li>
                <li>{t('privacy.collection.provided.item2')}</li>
                <li>{t('privacy.collection.provided.item3')}</li>
                <li>{t('privacy.collection.provided.item4')}</li>
                <li>{t('privacy.collection.provided.item5')}</li>
              </ul>
              
              <h4 className="text-lg font-medium mb-2">{t('privacy.collection.automatic.title')}</h4>
              <p className="mb-4">{t('privacy.collection.automatic.intro')}</p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>{t('privacy.collection.automatic.item1')}</li>
                <li>{t('privacy.collection.automatic.item2')}</li>
                <li>{t('privacy.collection.automatic.item3')}</li>
                <li>{t('privacy.collection.automatic.item4')}</li>
                <li>{t('privacy.collection.automatic.item5')}</li>
              </ul>
            </section>
            
            <section>
              <h3 className="text-xl font-semibold mb-3">{t('privacy.usage.title')}</h3>
              <p className="mb-4">{t('privacy.usage.intro')}</p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>{t('privacy.usage.item1')}</li>
                <li>{t('privacy.usage.item2')}</li>
                <li>{t('privacy.usage.item3')}</li>
                <li>{t('privacy.usage.item4')}</li>
                <li>{t('privacy.usage.item5')}</li>
                <li>{t('privacy.usage.item6')}</li>
              </ul>
            </section>
            
            <section>
              <h3 className="text-xl font-semibold mb-3">{t('privacy.sharing.title')}</h3>
              <p className="mb-4">{t('privacy.sharing.intro')}</p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>{t('privacy.sharing.item1')}</li>
                <li>{t('privacy.sharing.item2')}</li>
                <li>{t('privacy.sharing.item3')}</li>
                <li>{t('privacy.sharing.item4')}</li>
              </ul>
            </section>
            
            <section>
              <h3 className="text-xl font-semibold mb-3">{t('privacy.retention.title')}</h3>
              <p className="mb-4">{t('privacy.retention.text')}</p>
            </section>
            
            <section>
              <h3 className="text-xl font-semibold mb-3">{t('privacy.rights.title')}</h3>
              <p className="mb-4">{t('privacy.rights.intro')}</p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>{t('privacy.rights.item1')}</li>
                <li>{t('privacy.rights.item2')}</li>
                <li>{t('privacy.rights.item3')}</li>
                <li>{t('privacy.rights.item4')}</li>
                <li>{t('privacy.rights.item5')}</li>
              </ul>
              <p className="mb-4">{t('privacy.rights.contact')}</p>
            </section>
            
            <section>
              <h3 className="text-xl font-semibold mb-3">{t('privacy.security.title')}</h3>
              <p className="mb-4">{t('privacy.security.text')}</p>
            </section>
            
            <section>
              <h3 className="text-xl font-semibold mb-3">{t('privacy.changes.title')}</h3>
              <p className="mb-4">{t('privacy.changes.text')}</p>
            </section>
            
            <section>
              <h3 className="text-xl font-semibold mb-3">{t('privacy.contact.title')}</h3>
              <p className="mb-4">{t('privacy.contact.intro')}</p>
              <p className="mb-2"><strong>{t('privacy.contact.email')}:</strong> infos@socabeg.com</p>
              <p className="mb-2"><strong>{t('privacy.contact.phone')}:</strong> +221 33 889 35 35</p>
              <p className="mb-2"><strong>{t('privacy.contact.address')}:</strong> Fann-Hock – Corniche face Cour Suprême, BP 1270, Dakar, Sénégal</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialite;
